import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1 } from '../apis.js';
const reqImports = collectionEngineV1('/imports', true);
export const addAppendix = (importId, fileId) => reqImports('POST', `/${importId}`, {
    body: { fileId },
});
export const getAppendices = (importId) => reqImports('GET', `/appendices/${importId}`);
export const getAmountAppendices = (importId) => reqImports('GET', `/amount-appendices/${importId}`);
export const get = (importId) => reqImports('GET', `/${importId}`);
export const create = (data) => reqImports('POST', '/', {
    body: data,
});
export const del = (importId) => reqImports('DELETE', '/' + importId);
export const saveMapping = (importId, details) => reqImports('PUT', `/${importId}/mapping`, { body: details });
export const patch = (importId, patch) => reqImports('PATCH', `/${importId}`, {
    body: patch,
});
export const getMigrationSample = (authToken, from, config) => reqImports('GET', `/migrate?from=${from}&config=${JSON.stringify(config)}`);
export const getAllImports = (filter, page, pageSize) => {
    return reqImports('GET', `/?${toQuery({ page, pageSize, ...filter })}`);
};
export const newCaseUpload = (importId, map, options = {}) => reqImports('PUT', `/${importId}/start`, {
    body: {
        map,
        sheetMappings: options.sheetMappings,
    },
});
export const getFailedRows = (importId) => reqImports('GET', '/get-failed/' + importId);
export const importDebtorMessages = (body) => {
    return reqImports('POST', '/import-debtor-messages', { body });
};
export const getProgress = (importId) => reqImports('GET', `/${importId}/progress`);
export const retryImport = (importId) => reqImports('POST', `/${importId}/retry`, { body: {} });
//# sourceMappingURL=imports.js.map